/* @flow */

import React, { Component } from 'react';

export default class SubHeaderRow extends Component {
  render() {
    if (this.props.tab === 3) {
      return (
        <tr className='warning'><td width='50'>Date</td><td width='50'>Time</td><td width='50'>Venue</td><td width='100'>Subspecialty</td><td width='60' >Presentation Type</td><td width='250' >Theme</td><td width='80'>Involvement</td><td width='80'>	Sequence/Topic(s)</td></tr>
      );
    } else {
      return (
        <tr className='warning'><td width='50'>Date</td><td width='50'>Time</td><td width='50'>Venue</td><td width='100'>Subspecialty</td><td width='60' >Presentation Type</td><td width='250' >Theme</td><td width='80'>Chair(s)</td></tr>
      );
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/subHeaderRow.js
 **/